export default {
    notifications: [],
    notificationsQuantity: 0,
};
